import { connect } from 'react-redux';
import LineDetails from './LineDetails';
import { selectors as purchaseOrdersSelectors } from 'ducks/purchaseOrders/purchaseOrders';
import { getFormValues, reset, destroy, isDirty, change } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
const params = new URLSearchParams(location.search);
const FORM_NAME = 'PurchaseOrderLineDetailsForm';
const mapStateToProps = (state: IApplicationState) => ({
    purchaseOrder: purchaseOrdersSelectors.selected(state)?.PurchaseOrder ?? params.get('PurchaseOrder'),
    dirty: isDirty(FORM_NAME)(state),
    formValues: getFormValues(FORM_NAME)(state),
    selectedRecord: purchaseOrdersSelectors.selected(state)
});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        changeFieldValue: (field, value) => change(FORM_NAME, field, value),
        resetForm: () => reset(FORM_NAME),
        destoryForm: () => destroy(FORM_NAME),
    },
    dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LineDetails);
